export default __webpack_public_path__ + "static/media/cash.8703cb28.svg";